























import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  props: {
    isExpanded: Boolean,
    canCollapse: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    expand() {
      this.$emit("expand");
    },
    collapse() {
      this.$emit("collapse");
    },
  },
});
